<template>
    <div id="app">

        <Login v-if="!$store.state.auth.token"></Login>

        <template v-else="">
            <div id="menuBtn" @click="toggleMenu()">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>
            <div id="menu" class="scroll" :class="{show: showMenu}">
                <ul>
                    <li v-for="route in menuRoutes()" @click="goToPath(route.path)" :class="{active: current(route.path)}">
                        <i :class="route.component.icon"></i> {{ $t(route.component.title) }}
                    </li>
                    <li @click="logout">
                        <i class="fas fa-sign-out-alt"></i> {{ $t('action.logout') }}
                    </li>
                </ul>
            </div>
            <div id="content" class="scroll">
                <router-view/>
            </div>
        </template>
    </div>
</template>

<script>
    import Login from '@/views/Login'

    export default {
        name: "App",
        components: {Login},
        data() {
            return {
                showMenu: false
            }
        },
        methods: {
            menuRoutes() {
                return this.$router.options.routes.filter(
                    function (route) {
                        return route.showInMenu;
                    }
                );
            },
            goToPath(path) {
                this.$router.push({path:path});
                this.toggleMenu();
            },
            current(path) {
                return this.$router.currentRoute.path === path;
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            },
            logout() {
                if (confirm(this.$t('action.logoutConfirmationMessage'))) {
                    localStorage.removeItem('auth');
                    this.$store.state.auth.token = null;
                }
            }
        }
    };
</script>

<style lang="less" src="@/assets/app.less"></style>